export const baseClientEnvironment = {};
